import React, { FC } from 'react';

import { Box, SxProps, Typography } from '@mui/material';

import {
  ILongTermContractModel,
  PharmacistLegendVariant,
} from '@pharmaplan/common';

import getLongTermContractLabels from '../../../common/LongTermContractLabels';
import PharmacyInfoCard from '../../../common/PharmacyInfoCard';
import ThemeConstants from '../../../../theme/ThemeConstants';
import WithSkeleton from '../../../common/WithSkeleton';
import StackedBox from '../../../common/StackedBox';
import strings from '../../../../localization';
import ServiceCard from '../../ServiceCard';

import styles from './styles';

interface ILongShiftCardDetails {
  event: {
    firstName?: string;
    name?: string;
    lastName?: string;
    profilePicture: string | null;
    postalCode: string;
    longTermShiftContract: ILongTermContractModel;
  };
  successAction: string;
  customContainerStyle?: SxProps;
}

const LongShiftCardDetails: FC<ILongShiftCardDetails> = ({
  event,
  successAction,
  customContainerStyle,
}) => {
  const {
    firstName,
    lastName,
    profilePicture,
    postalCode,
    longTermShiftContract,
  } = event ?? {};

  const {
    startDate: contractStart,
    endDate: contractEnd,
    longTermShiftContractId,
  } = longTermShiftContract ?? {};

  const SkeletonTypography = WithSkeleton({ successAction, variant: 'text' })(
    Typography,
  );

  const { ShiftLabel } = getLongTermContractLabels({
    successAction,
    contractEndDate: contractEnd,
    contractStartDate: contractStart,
    isLongTerm: !!longTermShiftContractId,
  });

  return (
    <StackedBox
      showStacks
      sx={[styles.stackContainer, customContainerStyle] as SxProps}
      backgroundColor={ThemeConstants.stackedChips.postedChip}
    >
      <ServiceCard
        customContainerStyle={{ mb: 0, pt: '10px', pr: '10px' }}
        eventType={PharmacistLegendVariant.workshift}
        content={(
          <Box sx={styles.cardContainer}>
            <ShiftLabel />
            <Box sx={{ display: 'flex', my: 1 }}>
              <PharmacyInfoCard
                successAction={successAction}
                logoImage={profilePicture ?? ''}
                title={event?.name ?? `${firstName} ${lastName}`}
                longTermAttributes={{
                  contractEnd,
                  contractStart,
                  longTermShiftContractId,
                }}
              />
            </Box>
          </Box>
        )}
        footer={(
          <Box sx={styles.footerContainer}>
            <SkeletonTypography sx={styles.footerLabel}>
              {strings.postalCode}
            </SkeletonTypography>
            <SkeletonTypography sx={styles.footerValue}>
              {postalCode}
            </SkeletonTypography>
          </Box>
        )}
      />
    </StackedBox>
  );
};

export default LongShiftCardDetails;
